import React, { useEffect, useState } from 'react';
import { collection, getDocs, query } from 'firebase/firestore';
import { db } from '../lib/firebase'; 
import { useNavigate } from 'react-router-dom';
import { dummy } from '../assets'; 
import Loader from '../loader/Loader';
import './users.css'; 

const AllUsers = () => { 
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersQuery = query(collection(db, 'users')); // No limit on the query
        const querySnapshot = await getDocs(usersQuery);
        const usersList = await Promise.all(querySnapshot.docs.map(async (doc) => {
          const userData = doc.data();
          const userId = doc.id;

          // Calculate the user's balance
          const userTransactions = userData.transactions || [];
          const userBalance = userTransactions.reduce((total, transaction) => {
            return transaction.type === 'credit' ? total + transaction.amount : total - transaction.amount;
          }, 0);

          return {
            id: userId,
            fullName: userData.fullName,
            email: userData.email,
            profilePictureUrl: userData.profilePictureUrl || dummy,
            role: userData.role || 'User',
            group: userData.group || 'General',
            gender: userData.gender || 'Null',
            accountBalance: userBalance.toFixed(2) // Calculate and format balance
          };
        }));
        
        setUsers(usersList);
        setFilteredUsers(usersList); // Initialize filteredUsers
        setLoading(false);
      } catch (error) {
        console.error('Error fetching users: ', error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    // Filter users based on search term
    const filtered = users.filter(user =>
      user.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filtered);
  }, [searchTerm, users]);

  
  const handleUserClick = (userId) => {
    navigate(`/users/${userId}`); // Navigate to user detail page
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="all-users-container pageCover">
    <div className="all-users-container">
  <div className="search-bar-container">
    <input
      type="text"
      placeholder="Search users..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className="search-bar"
    />
  </div>
  {filteredUsers.length > 0 ? (
    <table className="user-table">
      {/* Table content */}
    </table>
  ) : (
    <p className="no-users">No users found</p>
  )}
</div>

      {filteredUsers.length > 0 ? (
        <table className="user-table">
          <thead>
            <tr>
              <th>Profile</th>
              <th>Full Name</th>
              <th className='pc'>Email</th>
              <th className='pc'>Role</th>
              <th className='pc'>Group</th>
              <th className='pc'>Gender</th>
              <th>Account Balance</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map(user => (
              <tr key={user.id} onClick={() => handleUserClick(user.id)}>
                <td><img src={user.profilePictureUrl} alt={`${user.fullName}'s profile`} className="profile-pic" /></td>
                <td>{user.fullName}</td>
                <td className='pc'>{user.email}</td>
                <td className='pc'>{user.role}</td>
                <td className='pc'>{user.group}</td>
                <td className='pc'>{user.gender}</td>
                <td>${user.accountBalance}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="no-users">No users found!</p>
      )}
    </div>
  );
};

export default AllUsers;
